<template>
    <div class="position-relative" ref="dropdownContainer">
        <a 
            v-if="!activity.deleted_at"
            class="btn-configuration-dropdown-actions" 
            :class="{ open: showDropdown }" 
            @mouseenter="handleMouseEnter"
            @mouseleave="handleMouseLeave"
            data-ignore-unsaved-check
            @click="toggleDropdown"
        >
            <MenuOptions 
                :isHovered="isHovered"
                :isOpen="showDropdown"
                class="icon-svg" 
            />
        </a>
        <div v-if="isHovered" class="tooltip-container">
            <div class="tooltip-arrow"></div>
            <div class="tooltip-content">
                {{ __("Ações") }}
            </div>
        </div>
        <ul v-if="showDropdown" role="menu" tabindex="-1" class="dropdown-menu-dropdown-actions z-index-10000">
            
            <li 
                v-for="(item, index) in dropdownItems" 
                :key="index" 
                role="presentation"
                v-if="shouldShowItem(item)"
            >
                <a 
                    role="menuitem" 
                    @click="item.action"
                    :class="{ 'disabled': mustHideFixItem(item) || mustHideUnpinItem(item) }"
                    class="dropdown-item-drop-dropdown-actions"
                    target="_blank"
                    data-ignore-unsaved-check
                >
                <span>{{ __(item.label) }}</span>
                </a>
            </li>
        </ul>
    </div>
</template>
<script>
import MenuOptions from "../MenuOptions.vue";

export default {
    components: {
        MenuOptions,
    },

    props: {
        activity: {
            type: Object,
            required: true
        },
        totalFixedActivities: {
            type: Number,
            required: true
        }
    },
    
    computed: {
        filteredDropdownItems() {
            return this.dropdownItems.filter(item => {
                if (item.id === 'fix') {
                    return !this.activity.fixed && (this.totalFixedActivities) < 3;
                }
                return true;
            });
        },

        shouldShowItem() {
            return function(item) {
                if (!this.activity || !this.activity.id) return false;
                
                // Don't show calendar for notes
                if (this.activity.type.key === 'note' && item.id === 'calendar') return false;

                // Don't show calendar for activities without scheduled
                if (item.id === 'calendar' && !this.activity.scheduled_at) return false;
                
                // Do not show edit/delete for completed activities
                if ((item.id === 'edit' || item.id === 'delete') && this.activity.completed_at) return false;
                
                return true;
            }
        }
    },

    data() {
        return {
            showDropdown: false,
            isHovered: false,
            dropdownItems: [
                { label: "Abrir agendamento", action: () => { window.location.href = '/calendar'; }, id: 'calendar' },
                { label: "Editar", action: this.editActivity, id: 'edit' },
                { label: "Excluir", action: this.openDeleteActivityModal, id: 'delete'},
                { label: "Fixar", action: this.fixActivity, id: 'fix' },
                { label: "Desafixar", action: this.unpinActivity, id: 'unpin' }
            ],
        };
    },

    methods: {
        mustHideUnpinItem(item) {
            if (item.id === 'unpin') {
                return this.activity.fixed ? false : true;
            }
            return false;
        },

        mustHideFixItem(item) {
            if (item.id === 'fix') {
                return this.activity.fixed || (this.totalFixedActivities) >= 3;
            }
            return false;
        },

        openDeleteActivityModal() {
            Bus.$emit('openDeleteActivityModal', this.activity);
        },

        toggleDropdown() {
            this.showDropdown = !this.showDropdown;
            if (this.showDropdown) {
                this.isHovered = false;
            }
        },
        handleMouseEnter() {
            if (!this.showDropdown) {
                this.isHovered = true;
            }
        },
        handleMouseLeave() {
            this.isHovered = false;
        },

        editActivity() {
            this.$emit('edit-activity', this.activity);
            this.toggleDropdown();
        },

        fixActivity() {
            if ((this.totalFixedActivities) < 3) {
                this.$emit('updateFixedActivityCount', {activity: this.activity, isFixing: true});
                this.toggleDropdown();
            }
        },

        unpinActivity() {
            this.$emit('unpin', {activity: this.activity, isFixing: false});
            this.toggleDropdown();
        },

        handleClickOutside(event) {
            if (this.showDropdown && !this.$refs.dropdownContainer.contains(event.target)) {
                this.showDropdown = false;
            }
        },
    },
    mounted() {
        Bus.$on('closeDropdown', () => {
            this.showDropdown = false;
        });

        document.addEventListener('click', this.handleClickOutside);
    },
    beforeDestroy() {
        Bus.$off('closeDropdown');
        document.removeEventListener('click', this.handleClickOutside);
    }
};
</script>
  
<style scoped>
.btn-configuration-dropdown-actions {
    width: 26px !important;
    height: 26px !important;
    background: #F4F1FF !important;
    border: 1px solid #ECE7FF !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 8px !important;
    transition: background 0.3s ease-in-out !important;
    cursor: pointer;
}

.btn-configuration-dropdown-actions:hover {
    background: #5F33FF !important;
    border: 1px solid #9375FF !important;
}

.btn-configuration-dropdown-actions.open {
    background: #9375FF !important;
}

.icon-svg {
    display: block;
}

.dropdown-menu-dropdown-actions {
    list-style: none;
    position: absolute;
    top: 36px;
    right: 0;
    width: 153px;
    background: #FFFFFF;
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    padding: 8px;
    gap: 4px;
    cursor: pointer;
}

.dropdown-item-drop-dropdown-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 137px;
    height: 26px;
    background: #FFFFFF;
    font-family: 'Montserrat', sans-serif;
    font-size: 12px;
    font-weight: 500;
    color: #71767D !important;
    text-decoration: none;
    transition: background 0.2s ease-in-out;
    border-radius: 4px;
    padding: 5.5px 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.dropdown-item-drop-dropdown-actions:not(:last-child) {
    margin-bottom: 4px;
}

.dropdown-item-drop-dropdown-actions:hover {
    background: #F1F5F9;
    font-family: 'Montserrat', sans-serif;
    font-size: 12px;
    font-weight: 500;
    color: #242424;
}

.tooltip-container {
  position: absolute !important;
  bottom: -38px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  z-index: 1000 !important;
  top: 36px !important;
  width:auto;
}

.tooltip-arrow {
  width: 0 !important;
  height: 0 !important;
  border-left: 6px solid transparent !important;
  border-right: 6px solid transparent !important;
  border-bottom: 6px solid #000000 !important;
  position: absolute !important;
  top: -6px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
}

.tooltip-content {
  background: #000000;
  color: #FFFFFF;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
  border-radius: 8px;
  padding: 4px 8px;
  white-space: nowrap;
}

.disabled {
    display: none !important;
}

.z-index-10000 {
    z-index: 10000 !important;
}
</style>